<div class="mb-4 flex gap-4 pt-[22px]">
  @for (item of tabs; track item.id) {
    <button
      class="btn-secondary relative mx-1 flex-grow-0 border-0 px-0 pb-2 pt-1"
      [ngClass]="{
        'active typo-h4-semibold': activeTabId() === item.id,
        '!text-[16px] !font-light text-text-tertiary': activeTabId() !== item.id
      }"
      (click)="setActiveTabId(item.id)"
    >
      {{ item.label | translate }}
    </button>
  }
</div>
<div class="flex h-full w-full items-center">
  <button class="arrow left flex h-[84px] w-[52px] items-center justify-center" (click)="onLeftClick()">
    <svg-icon class="text-primary-blue" key="px-16-arrow-left" size="sm"></svg-icon>
  </button>

  <div class="flex flex-1 flex-col items-center">
    @if (!!toothHistorySignal()) {
      <div class="typo-h7-light leading-none text-text-black">{{ 'charting_details_column_title' | translate }}</div>
    }

    @if (activeTabId() === 'charting' && !toothHistorySignal()) {
      <ng-lottie currentColor class="my-5 text-primary-blue" [options]="lottieOptions"></ng-lottie>
    } @else {
      <div class="typo-h0 mb-4 text-text-primary">{{ currentToothPosition() }}</div>
      @if (activeTabId() === 'charting') {
        <lib-tooth
          class="h-[280px] w-[140px]"
          [tooth]="toothHistorySignal()![selectedIndex()]"
          [isToothMissing]="isToothMissing()"
          [inheritedMouseStyle]="true"
        ></lib-tooth>
      }

      @if (activeTabId() === 'perio' && perioHistorySignal(); as perioHistory) {
        @if (currentTooth()) {
          <h6 class="typo-h7-semibold mb-2 ml-8">
            {{ (currentTooth()?.jaw === 'upper' ? 'perio_common_label_facial' : 'perio_common_label_lingual') | translate }}
          </h6>
        }
        @if (perioHistory.length === 0) {
          <lib-perio-tooth
            [toothOnly]="true"
            class="h-[280px] w-[140px]"
            [tooth]="currentTooth() ?? DEFAULT_TEETH[0]"
            [drawLabels]="true"
          ></lib-perio-tooth>
        } @else {
          <lib-perio-tooth
            class="h-[280px] w-[140px]"
            [tooth]="
              perioHistory | findToothByDateAndPosition: currentToothPosition() : (selectedDate() ? selectedDate() : perioHistory[0].date)
            "
            [drawLabels]="true"
            [isPerioHistoryView]="false"
          ></lib-perio-tooth>
        }
        @if (currentTooth()) {
          <h6 class="typo-h7-semibold mb-2 ml-8 mt-2">
            {{ (currentTooth()?.jaw === 'upper' ? 'perio_common_label_lingual' : 'perio_common_label_facial') | translate }}
          </h6>
        }
      }
    }

    <div class="mt-2 flex" #toothHistoryWrapper>
      <div
        #toothHistory
        class="flex w-[75px]"
        [ngClass]="{
          'transition-all duration-500': !dragging(),
          'cursor-grabbing': dragging()
        }"
        [style.translate]="-selectedIndex() * 70 + 'px'"
      >
        @if (activeTabId() === 'charting') {
          <ng-container
            [ngTemplateOutlet]="historyItem"
            [ngTemplateOutletContext]="{ items: toothHistorySignal(), itemTemplate: chartingItem, type: 'charting' }"
          >
          </ng-container>
        } @else {
          <ng-container
            [ngTemplateOutlet]="historyItem"
            [ngTemplateOutletContext]="{ items: perioHistorySignal(), itemTemplate: perioItem, type: 'perio' }"
          >
          </ng-container>
        }
      </div>
    </div>
  </div>

  <button class="arrow right flex h-[84px] w-[52px] items-center justify-center" (click)="onRightClick()">
    <svg-icon class="text-primary-blue" key="px-16-arrow-right" size="sm"></svg-icon>
  </button>
</div>

<ng-template #historyItem let-items="items" let-itemTemplate="itemTemplate" let-type="type">
  @for (item of items; track $index) {
    @if (item.date) {
      <button
        #historyItemRef
        class="flex w-[75px] items-center justify-center rounded-full p-[2px]"
        [ngClass]="{
          '[background:radial-gradient(165.32%_63.35%_at_0%_62.82%,#47A4FB_0%,rgba(71,164,251,0.13)_100%)]': $index === selectedIndex(),
          'cursor-grabbing': dragging(),
          'cursor-pointer': !dragging(),
          '!transition-none': dragging()
        }"
        (click)="onHistoryItemClick(item.date, $index)"
        [ffdPushTagOnClick]="{
          event: TagEvent.ChartingHistoryViewed,
          patient_id: patientId
        }"
      >
        <div
          class="z-10 flex flex-col items-center rounded-full bg-background-white py-4"
          [ngClass]="{
            'px-2': type === 'charting',
            'px-[2px]': type === 'perio'
          }"
        >
          <div class="typo-h7-extralight">
            {{ item.date ? (item.date | date: 'MM/dd/yy') : '&nbsp;' }}
          </div>
          <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
        </div>
      </button>
    } @else {
      <div class="ms-[-8px] flex h-[176px] flex-col items-center pt-4">
        <div class="typo-h7-extralight whitespace-nowrap text-text-tertiary">{{ 'charting_details_no_tooth_history' | translate }}</div>
        <img src="assets/images/empty-tooth-history.png" class="h-[126px]" />
      </div>
    }
  }
</ng-template>

<ng-template #chartingItem let-item>
  <lib-tooth class="-z-10 h-[126px] w-[29px]" [tooth]="item" [toothOnly]="true" [inheritedMouseStyle]="true"></lib-tooth>
</ng-template>

<ng-template #perioItem let-item>
  <lib-perio-tooth
    class="-z-10 h-[126px] w-[60px]"
    [tooth]="item.teeth | findToothByPosition: currentToothPosition()"
    [toothOnly]="true"
    [isPerioHistoryView]="true"
  ></lib-perio-tooth>
</ng-template>
